import { render, staticRenderFns } from "./TkCheckbox.vue?vue&type=template&id=76a7561b&"
import script from "./TkCheckbox.vue?vue&type=script&lang=js&"
export * from "./TkCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports